<template>
	<sa-page-layout ref="SaplPostiLettoPianiView" :btnRouterBackVisible="true" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource">
		<!-- class="sa-no-space" -->
		<template slot="table-filter">
			<rsa-configurazione-posti-letto-letti-view-component ref="cmpRsaConfigurazionePostiLettoLettiView" @setLinkBack="onSetLinkBack"></rsa-configurazione-posti-letto-letti-view-component>
		</template>

		<template slot="table-body">
			<rsa-gestione-camere-storico-list-component ref="cmpGestioneCamereStoricoList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazionePostiLettoLettiViewComponent from "../components/RsaConfigurazionePostiLettoLettiViewComponent.vue";
import RsaGestioneCamereStoricoListComponent from "../../rsagestionecamere/components/RsaGestioneCamereStoricoListComponent.vue";
export default {
	components: { SaPageLayout, RsaConfigurazionePostiLettoLettiViewComponent, RsaGestioneCamereStoricoListComponent },
	data() {
		return {
			showModalLoading: false,
			pathResource: "/rsapostilettoletti",
			jsonData: {},
			id: "",
		};
	},
	mounted() {
		let me = this;
		me.id = this.$route.params.id;
		me.linkback = "/rsaconfigurazionepostilettostanze/view/";

		me.loadData();
	},
	methods: {
		loadData() {
			let me = this;
			me.$refs.cmpRsaConfigurazionePostiLettoLettiView.loadData(me.id);
			me.$refs.cmpGestioneCamereStoricoList.loadDataLettiStorico(me.id);
		},

		onBeforeLoadData() {
			let me = this;
			me.showModalLoading = true;
		},
		onAfterLoadData() {
			let me = this;
			me.showModalLoading = false;
		},
		onSetLinkBack(id) {
			let me = this;
			me.linkback = "/rsaconfigurazionepostilettostanze/view/" + id;
		},
	},
};
</script>

<style></style>
